import { useState } from "react";
import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const useToValidateKeyFobsQuantity = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const validateKeyFobsQuantity = async (payload) => {
    try {
      setData();
      setError("");
      setLoading(true);
      const { data } = await postRequest(urls.VALIDATE_KEY_FOB, payload);
      setData(data?.data ?? []);
    } catch (error) {
      setError(error?.response?.data?.message || "Unable to fetch the data");
      setData(error?.response?.data ?? []);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    error,
    isLoading,
    validateKeyFobsQuantity,
  };
};

export const validateKeyFobQuantity = async (payload) => {
  const { data } = await postRequest(urls.VALIDATE_KEY_FOB, payload);
  return data?.data ?? {};
};
